import React from "react"

const BurgerIcon: React.FC = () => (
  <svg
    width="27"
    height="20"
    viewBox="0 0 27 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26.6667" height="3.33333" rx="1.66667" fill="#0D112C" />
    <rect
      y="8.33334"
      width="26.6667"
      height="3.33333"
      rx="1.66667"
      fill="#0D112C"
    />
    <rect
      y="16.6667"
      width="26.6667"
      height="3.33333"
      rx="1.66667"
      fill="#0D112C"
    />
  </svg>
)

export default BurgerIcon
